import $ from 'jquery';

// global arg is expected to be the window object when run in a browser
export function cache_handler(global) {
    $.event.special.inputchange = {
        setup: () => {
            // If nothing is found, then do nothing and return early
            if (typeof this === 'undefined') {
                return;
            }
            let self = this;
            $.data(
                this,
                'timer',
                global.setInterval(() => {
                    let val = self.value;
                    if ($.data(self, 'cache') !== val) {
                        $.data(self, 'cache', val);
                        self.trigger('inputchange');
                    }
                }, 20)
            );
        },
        teardown: () => {
            // If nothing is found, then do nothing and return early
            if (typeof this !== 'undefined') {
                global.clearInterval($.data(this, 'timer'));
            }
        },
        add: function() {
            // If nothing is found, then do nothing and return early
            if (typeof this !== 'undefined') {
                $.data(this, 'cache', this.value);
            }
        },
    };
}
